import { QuestionCircleOutlined } from '@ant-design/icons'
import { Collapse, Tooltip } from 'antd'
import React from 'react'
import { COLORS } from './format'

// Definiciones únicas: las usan los tooltips de las columnas y el glosario.
export const TERMS = {
  simple: {
    label: 'Simple',
    color: COLORS.simple,
    text: 'Mensaje cobrado suelto (0,05 €) porque el usuario no interactuó en sus 24 h y lleva botones, imagen, carrusel o más de 160 caracteres. Casi siempre es el mensaje inicial de quien no responde.'
  },
  basico: {
    label: 'Básico',
    color: COLORS.basico,
    text: 'Mensaje cobrado suelto a la tarifa más barata (0,021 €): solo texto, de 160 caracteres o menos, sin botones ni imágenes (las tildes no importan). En nuestros flujos son las respuestas automáticas de flujo cerrado.'
  },
  conversacion: {
    label: 'Conversación',
    color: COLORS.conversacion,
    text: 'El usuario interactúa (pulsa un botón o escribe) y se abre una sesión de 24 h (0,05 €); todo lo que le enviamos en esas 24 h va incluido. Si responde dentro de las 24 h del mensaje inicial, ese mensaje también va incluido; si responde más tarde, el inicial ya se cobró como Simple. Abrir o ver el mensaje NO cuenta.'
  },
  extra: {
    label: 'Sesión extra',
    color: COLORS.extra,
    text: 'El mismo teléfono vuelve a interactuar después de que caduquen las 24 h de su conversación: se abre otra sesión y se cobra otra vez (0,05 €).'
  },
  incluido: {
    label: 'Incluido',
    color: COLORS.incluido,
    text: 'Respuesta del bot enviada dentro de una conversación ya cobrada: no se cobra (0 €). Solo contamos lo que envía el bot; lo que escribe o pulsa la persona nunca se cobra.'
  },
  fallido: {
    label: 'Fallido',
    color: COLORS.fallido,
    text: 'Orange aceptó el mensaje pero el operador no lo pudo entregar o caducó. Puede haberse reenviado por SMS.'
  },
  contactados: {
    label: 'Teléfonos contactados',
    text: 'Números distintos a los que se envió el mensaje inicial en el periodo.'
  },
  cobrado: {
    label: 'Cobrado al cliente',
    text: 'Lo que facturamos al cliente: tarifa plana por cada mensaje inicial cobrado, interactúe o no.'
  },
  coste: {
    label: 'Coste Orange',
    text: 'Lo que nos cobra Orange, calculado con sus tres tarifas. Contra la factura real de agosto: 1.233,79 € frente a 1.233,63 € (+0,01 %).'
  }
}

// Título de columna con icono de ayuda
export const Term = ({ id, children }) => (
  <Tooltip title={TERMS[id] ? TERMS[id].text : ''}>
    <span style={{ cursor: 'help', whiteSpace: 'nowrap' }}>
      {children || (TERMS[id] && TERMS[id].label)}{' '}
      <QuestionCircleOutlined style={{ color: '#94a3b8', fontSize: 11 }} />
    </span>
  </Tooltip>
)

const ORDER = ['simple', 'basico', 'conversacion', 'extra', 'incluido', 'fallido', 'coste', 'cobrado']

const Glossary = () => (
  <Collapse ghost style={{ marginBottom: 12 }}>
    <Collapse.Panel header="¿Qué significa cada concepto? ¿Qué se cobra?" key="g">
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '10px 24px',
          fontSize: 13
        }}
      >
        {ORDER.map((k) => (
          <div key={k} style={{ display: 'flex', gap: 8 }}>
            {TERMS[k].color && (
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 2,
                  background: TERMS[k].color,
                  marginTop: 5,
                  flex: 'none'
                }}
              />
            )}
            <div>
              <b>{TERMS[k].label}.</b>{' '}
              <span style={{ color: '#475569' }}>{TERMS[k].text}</span>
            </div>
          </div>
        ))}
      </div>
      <div style={{ marginTop: 12, fontSize: 12, color: '#64748b' }}>
        Ejemplo: se envía el mensaje inicial a un teléfono. Si no responde en 24 h, ese mensaje se
        cobra como Simple. Si pulsa un botón dentro de esas 24 h, se cobra una Conversación (que
        incluye el inicial) y todo lo que le enviamos en las 24 h siguientes va incluido. Si vuelve
        a escribir días después, es una Sesión extra. Si escribe cuando su flujo ya está cerrado,
        recibe la respuesta automática de flujo cerrado, que se cobra como Básico.
      </div>
    </Collapse.Panel>
  </Collapse>
)

export default Glossary
